import React, { useEffect, useRef } from 'react';

import { el, setChildren } from 'redom';

// The panels are downloaded when one is first opened; the menu item opens at once with a spinner.
// props.panel names the creator: 'createLayoutSettings' or 'createItemSettings'.
// props.value is the editor value; a new one makes the panel check for outside changes such as undo.
function LayoutSettingsReactWrapper(props) {

  const mountReference = useRef(null);
  const panelReference = useRef(null);
  const propsReference = useRef(props);

  propsReference.current = props;

  useEffect(function onValueChange() {

    if (panelReference.current === null) {
      return;
    }

    // The node can be gone for a moment before the menu closes, as when undo removes it.
    try {
      panelReference.current.refresh();
    } catch (exception) {
      return;
    }

  }, [props.value]);

  useEffect(function onLoad() {

    const mountPoint = mountReference.current;
    let unloaded = false;

    const configuration = {
      breakpoint: props.breakpoint,
      measure(isRow) {
        return propsReference.current.measure(isRow);
      },
      read(breakpoint) {
        return propsReference.current.read(breakpoint);
      },
      write(breakpoint, changes) {
        propsReference.current.write(breakpoint, changes);
      },
      reset(breakpoint, keys) {
        propsReference.current.reset(breakpoint, keys);
      }
    };

    async function loadPanel() {

      setChildren(mountPoint, [el('.layout-settings-loading', [el('ht-spinner', { size: 'small' })])]);

      try {
        const panels = await import('./');
        if (unloaded === false) {
          panelReference.current = panels[props.panel](configuration);
          setChildren(mountPoint, [panelReference.current]);
        }
      } catch (exception) {
        setChildren(mountPoint, [el('p.layout-field-note', 'These settings could not be loaded. Refresh the page to try again.')]);
      }

    }

    loadPanel();

    return function onUnload() {
      unloaded = true;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div className="layout-settings-react-wrapper" ref={mountReference}></div>;

}

export default LayoutSettingsReactWrapper;
